const MenuItemIcon = ({ icon }) => (
  <span className="menu-icon">
    <span className="svg-icon svg-icon-2">
      <i className={icon} />
    </span>
  </span>
)

export default MenuItemIcon
